import { render, staticRenderFns } from "./editInsured.vue?vue&type=template&id=5d062402&scoped=true&"
import script from "./editInsured.vue?vue&type=script&lang=js&"
export * from "./editInsured.vue?vue&type=script&lang=js&"
import style0 from "./editInsured.vue?vue&type=style&index=0&id=5d062402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d062402",
  null
  
)

export default component.exports